import React from 'react'
import injectSheet from 'react-jss'
import { withRouter } from 'react-router-dom'
import styles from './navigation.styles'
import BackLink from './back-link/back-link.container'
import NavLink from './nav-link/nav-link'

const Navigation = ({ classes, studentId, match, ready }) => {
  return (
    <nav className={classes.container}>
      {!ready && <div />}
      {ready && <BackLink />}
      <ul className={classes.nav}>
        <NavLink path={`/assessment-files/${match.params.assessmentFileId}`}>
          Cover
        </NavLink>
        <NavLink
          path={`/assessment-files/${match.params.assessmentFileId}/works`}>
          Work
        </NavLink>
      </ul>
    </nav>
  )
}

export default withRouter(injectSheet(styles)(Navigation))
